import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { WsColors, WsTypography } from 'wisestep-base';

import { useComposableDashboardsFiltersContext } from '../../../../features/analyticsPage/hooks/useComposableDashboardsFiltersContext';
import usePostgreNoteWidgetsData from '../../DerivedCharts/ClientNotes/hooks/usePostgreNoteWidgetsData';
import { ClientNotesWidget } from '../../DerivedCharts/helper';
import { CustomNoRowsOverlay } from '../../helper/showCustomizeNoDataTextDataGrid';
import { StandardHeightsByRows } from '../../types';
import { IClientNotesDTO } from '../jobs/types/postgreJobsDTO';
import { IClientNotesWidgetProp } from '../jobs/types/postgreJobsWidgetProp';

import { defaultClientNotesWidgetData, getClientNotesColumns } from './utils/clientNotesHelper';

const ClientNotesTablePostgre = ({
  query,
  title,
  widgetName = ClientNotesWidget.TABLE_CLIENT,
}: IClientNotesWidgetProp) => {
  const { widgetData } = usePostgreNoteWidgetsData<IClientNotesDTO>(
    query,
    defaultClientNotesWidgetData
  );
  const { restructuredFilters } = useComposableDashboardsFiltersContext();
  const rowNum = 5;
  const data = widgetData.resultSet?.map((result, index) => ({
    id: index,
    clientId: result.clientId,
    clientContactId: result.clientContactId,
    recruiterEmail: result.recruiterEmail,
    count: result.count,
    clientName: result.clientName,
    clientContactName: result.clientContactName,
    recruiterName: result.recruiterName,
    ...(result.countByType ?? {}),
  }));

  return (
    <Box>
      <WsTypography bold={true}>{title}</WsTypography>
      <Box mt={1.5} style={{ height: StandardHeightsByRows[rowNum], background: WsColors.White }}>
        <DataGrid
          columns={getClientNotesColumns(widgetName, widgetData, query, restructuredFilters)}
          rows={data ?? []}
          components={{ Toolbar: GridToolbar, NoRowsOverlay: CustomNoRowsOverlay }}
          pageSize={rowNum}
          rowsPerPageOptions={[rowNum]}
          initialState={{
            sorting: {
              sortModel: [{ field: 'count', sort: 'desc' }],
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ClientNotesTablePostgre;
